import React from 'react';
import Typography from '@mui/material/Typography';

const Title = (props) => {
	return(
		<Typography variant="h2">{props.text}</Typography>
	)
}

export default Title;